import {useLayoutEffect,useRef} from 'react';
import type {Card,Snapshot} from '@platform/contracts/x';
import {hasParticipation,isFinished} from './roomFlow';

// Remember only the order actually seen by this spectator. The existing single
// viewed transition supplies its final cells, including recovered results;
// no extra history or requests.
export function useSpectatorBackdrop(view:Snapshot|null,ranked:Card[],previous:Snapshot|null){
 const seen=useRef<{drawId:string;ids:string[]}|null>(null);
 useLayoutEffect(()=>{
  if(!view)return;
  if(hasParticipation(view)){seen.current=null;return;}
  if(view.balls.length&&ranked.length&&(view.status==='Live'||view.status==='Completed'))
   seen.current={drawId:view.drawId,ids:ranked.map(card=>card.id)};
 },[view,ranked]);
 const starting=view&&!hasParticipation(view)&&(view.status==='Preparing'||view.status==='Live'&&view.balls.length===0);
 if(!starting||!previous||!seen.current||previous.drawId!==seen.current.drawId||previous.drawId===view.drawId||!isFinished(previous)||hasParticipation(previous))return null;
 const cards=new Map(previous.cards.map(card=>[card.id,card]));
 return {state:previous,ranked:seen.current.ids.map(id=>cards.get(id)).filter((card):card is Card=>!!card)};
}
